export default "__VITE_ASSET__e5efc71a__"